import { z } from 'zod';

import { ContactInfo } from '../contactInfo/ContactInfo';

interface ParentOrganizationMetadata {
  contact?: ContactInfo;
}

const ParentOrganizationMetadata = z.object({
  contact: ContactInfo.optional(),
});

export { ParentOrganizationMetadata };
